exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cookie-manager-main-container .cookie-setting{margin-top:10px;margin-bottom:10px}.cookie-manager-main-container .cookie-setting .main-info{position:relative}.cookie-manager-main-container .cookie-setting .detailed-info{margin-top:15px}.cookie-manager-main-container .cookie-setting .details-row{display:none}.cookie-manager-main-container .cookie-setting .collapse-details{cursor:pointer;margin:5px;color:#32d69a;font-family:Open Sans,sans-serif!important}.cookie-manager-main-container .cookie-setting .local-switcher{position:absolute;top:5px;right:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??ref--2-2!./node_modules/sass-loader/lib/loader.js!./src-cookie-manager/views/pages/details/partials/cookie-setting/style.scss
// module id = 433
// module chunks = 0